<div>
    <table class="table table-fixed  table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th scope="col">Risk Factors</th>
            <th scope="col">Ratings</th>
            <th scope="col">MS</th>
          </tr>
        </thead>
        <tbody class="table-group-divider">
          <tr *ngFor="let row of rows; let i = index">
            <th scope="row">{{ row.parameter }}</th>
            <td>
              <input
                type="number"
                [(ngModel)]="row.value"
                (input)="calculateResult(i)"
                placeholder="Enter value"
              />
            </td>
            <td>
              <input
                type="number"
                [(ngModel)]="row.ms"
                (input)="calculateResult(i)"
                placeholder="Enter value"
              />
            </td>
        
          </tr>
        </tbody>

        <tfoot>
            <tr>
              <th colspan="1">Average</th>
              <td >{{ calculateRatings() | number: '1.2-2' }}</td>
              <td>{{ calculateMS() | number: '1.2-2' }}</td>
            </tr>
        </tfoot>
      </table>
</div>

